/** Identifier of the type of a question */
export enum SurveyQuestionType {
  RatingWithFreeFormComment = 'RatingWithFreeFormComment',
  PersonRatingWithFreeFormComment = 'PersonRatingWithFreeFormComment',
  RecommendedRoles = 'RecommendedRoles',
  Comment = 'Comment',
  YesOrNo = 'YesOrNo',
  List = 'List',
}
